export default "__VITE_ASSET__BJSGoWAq__"